module.exports = __webpack_public_path__ + "static/media/IMG_0697 - Version 2.6388ca6c.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/images/large/IMG_0697 - Version 2.JPG
// module id = 541
// module chunks = 0